import React from "react";
import ShopifySVG from "../../../../../assets/svg/shopify.svg";
import WordpressSVG from "../../../../../assets/svg/wordpress.svg";
import { DestinationTypeEnum } from "../../../../../enums/destination";
import { AllDestinations } from "../../../../../models/destination";

function getDestinationImage(type: DestinationTypeEnum) {
  switch (type) {
    case DestinationTypeEnum.WORDPRESS:
      return WordpressSVG;
    case DestinationTypeEnum.SHOPIFY:
      return ShopifySVG;
    default:
      return WordpressSVG;
  }
}

export function DestinationNameColumn({
  destination,
}: {
  destination: AllDestinations;
}) {
  return (
    <div className="flex items-center gap-3">
      <img
        alt="destination-logo"
        src={getDestinationImage(destination.destinationTypeId)}
        className="size-5"
      />
      <div className="truncate overflow-hidden">{destination.name}</div>
    </div>
  );
}
